export default "/images/c38cab144cf31e88be4c4dc6618048d6.avif";